<template>
    <div ref="contentWrapper">
        <slot v-if="showContent" />
    </div>
</template>

<script setup lang="ts">
import { useIntersectionObserver } from '@vueuse/core'

const contentWrapper = ref(null)
const showContent = ref(false)

// Observes as soon as the wrapper ref is filled and disconnects on unmount.
const { stop } = useIntersectionObserver(contentWrapper, ([entry]) => {
    if (entry?.isIntersecting) {
        showContent.value = true
        stop()
    }
})
</script>
